
import axios from 'axios'


function getConfigurations() {
    return axios.get(`${process.env.VUE_APP_APIURL}/deviceConfigurations/0`/*0 => verison code */).then(res => {
        res.data.sensorSelections=[res.data.sensorSelections[0]]
        return res.data
    })
}

export default {
    getConfigurations
};